import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import Dots from "./Dots";

const faqs = [
  {
    question: "Does B.E.T.H. AI support multiple languages?",
    answer:
      "Yes, the chatbot can communicate in multiple languages. Just let it know your preferred language and it will respond accordingly.",
  },
  {
    question: "How secure is my information when using B.E.T.H. AI?",
    answer:
      "Your privacy is important to us. So we ensured that B.E.T.H. AI uses secure protocols to protect your personal information.",
  },
  {
    question: "Does B.E.T.H. AI provide energy efficiency tips?",
    answer:
      "Absolutely! Just ask for energy-saving tips, and it’ll provide helpful suggestions to reduce your consumption.",
  },
  {
    question: "What is the best way to contact customer service?",
    answer:
      "You can reach customer service through this chat, by phone, or via email. It can provide specific contact details if needed.",
  },
];

const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="flex flex-col gap-20 px-40 pt-32 pb-48 bg-customSlate-400">
      <div className="flex flex-col items-center w-full mb-8">
        <h1 className="text-3xl font-bold text-center text-customText-900">
          Frequently Asked Questions
          <div className="top-0 w-full h-1 mt-0.5 rounded-full bg-customGreen-500" />
        </h1>
      </div>
      <div className="relative flex flex-col rounded-md shadow-sm bg-customSlate-300 shadow-black/30">
        <Dots classname="absolute top-0 left-0 z-0 -rotate-90 -translate-x-[40%] -translate-y-[40%] w-fit" />
        <Dots classname="absolute bottom-0 right-0 z-0 rotate-90 translate-x-[40%] translate-y-[40%] w-fit" />
        {faqs.map((faq, index) => {
          const isLast = index === faqs.length - 1;
          const isOpen = openIndex === index;
          const borderClass =
            !isLast || isOpen ? "border-b-2 border-b-customSlate-600" : "";
          return (
            <div
              key={index}
              className="z-10">
              <div
                className={`flex items-center justify-between w-full px-8 py-5 font-bold ${borderClass}`}>
                <span className="text-customText-900">{faq.question}</span>
                <div
                  className="p-0.5 h-fit rounded-full cursor-pointer ring-2 ring-customGreen-700"
                  onClick={() => toggleFAQ(index)}>
                  {isOpen ? (
                    <Minus
                      strokeWidth={4}
                      className="text-customGreen-700 size-4"
                    />
                  ) : (
                    <Plus
                      strokeWidth={4}
                      className="text-customGreen-700 size-4"
                    />
                  )}
                </div>
              </div>
              {isOpen && (
                <div
                  className={`w-full px-8 py-5 ${
                    !isLast ? "border-b-2 border-b-customSlate-600" : ""
                  }`}>
                  <li className="text-sm text-customText-800">{faq.answer}</li>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FAQs;
